// extracted by mini-css-extract-plugin
export default {"container":"RL-z","topReviewHeading":"SL-z","criticalReview":"TL-z","favorableReview":"UL-z","vsSeparator":"VL-z"};